module.exports = __webpack_public_path__ + "fonts/VetoSans-Medium_1.7de6d795.eot";